import { AsyncState, loadingAsyncState } from "widgets-for-react";
import { getNews, NewsResponse } from "./newsOverviewApi";
import { BasePageProps } from "../../components/page_renderer";

export interface NewsOverviewProps extends BasePageProps {
  kind: "newsOverview"
  pageTitle: string
  headerTitle: string
  description: string
  imageUrl: string
  imageUrlLarge: string
  phImageUrlSmall?: string
  phImageUrl: string
  phImageUrlLarge: string
  imageAlt: string
  pageSize: number
  key?: string
}

export interface NewsOverviewState {
  newsLoader: AsyncState<NewsResponse>
  currentPage: number
}

export const initialNewsResponse: NewsResponse = { totalResults: 0, news: [] }

export const initialState: (props: NewsOverviewProps) => NewsOverviewState = (props) => ({
  newsLoader: loadingAsyncState(getNews(1, props.pageSize), initialNewsResponse),
  currentPage: 1
})

export type NewsOverviewLayoutProps = NewsOverviewProps & NewsOverviewState & {
  setPage: (page: number) => void
}

export const resultsClass = "news-results"